function toggleConcerns() {
  const params = new URLSearchParams(window.location.search);
  const concernType = params.get('concern_type') || localStorage.getItem('concern_type');
  const skinEls = document.querySelectorAll('.skincare-concerns');
  const hairEls = document.querySelectorAll('.haircare-concerns');

  // console.log("Concern type:", concernType);

  // If elements not yet loaded, stop
  if (!skinEls.length && !hairEls.length) return;

  // console.log("skinEls", skinEls);
  // console.log("hairEls", hairEls);
  // Hide both first
  skinEls.forEach(el => el.style.display = 'none');
  hairEls.forEach(el => el.style.display = 'none');

  if (concernType === 'skin') {
    skinEls.forEach(el => el.style.display = '');
  }

  if (concernType === 'hair') {
    hairEls.forEach(el => el.style.display = '');
  }
}
function initializeSwatchUpdater() {
  // Get ALL product list containers
  const productLists = document.querySelectorAll(
    '.product-list, .product-facet__product-list'
  );
  if (productLists.length === 0) {
    console.warn('Product list container not found');
    return;
  }

  productLists.forEach(productList => {
    const productItems = productList.querySelectorAll(
      'product-item, .product-item'
    );

    productItems.forEach(productItem => {
      if (productItem.hasAttribute('data-swatch-initialized')) {
        productItem.setAttribute('data-swatch-initialized', 'false');
      }

      productItem.setAttribute('data-swatch-initialized', 'true');

      const swatchInputs = productItem.querySelectorAll('.color-swatch__radio');
      if (swatchInputs.length === 0) return;

      swatchInputs.forEach(input => {
        input.addEventListener('change', function () {
          if (this.checked) {
            const variantId = this.getAttribute('data-variant-id');
            updatePriceAndAtc(variantId, productItem);
          }
        });
      });
    });
  });
}

function observeProductListChanges() {
  let timeout;

  const observer = new MutationObserver((mutations) => {
    let shouldReinitialize = false;

    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        // Check if the added node itself is a product item
        if (
          node.matches?.('product-item, .product-item') &&
          !node.hasAttribute('data-swatch-initialized')
        ) {
          shouldReinitialize = true;
        }

        // Check if product items exist inside the added node
        const newProducts = node.querySelectorAll?.(
          'product-item:not([data-swatch-initialized]), .product-item:not([data-swatch-initialized])'
        );

        if (newProducts && newProducts.length > 0) {
          shouldReinitialize = true;
        }
      });
    });

    if (shouldReinitialize) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        initializeSwatchUpdater();
      }, 100); // debounce
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
/**
 * Update price display and ATC button ID based on variant
 * @param {string} variantId - The selected variant ID
 * @param {HTMLElement} productContainer - The specific product container element
 */
function updatePriceAndAtc(variantId, productContainer) {
  if (!variantId || !productContainer) {
    console.error('Missing variantId or productContainer');
    return;
  }
  
  // Get variant data from the swatch itself or from a data attribute
  const selectedSwatch = productContainer.querySelector(`input[data-variant-id="${variantId}"]`);
  
  if (!selectedSwatch) {
    console.error('Variant not found:', variantId);
    return;
  }
  
  // Option 1: Get price from data attributes on the swatch
  const variantPrice = selectedSwatch.getAttribute('data-price');
  const variantComparePrice = selectedSwatch.getAttribute('data-compare-price');
  const variantDiscount = selectedSwatch.getAttribute('data-discount');
  
  // Option 2: Get price from a data attribute on the product item
  const variantDataStr = productContainer.getAttribute('data-variants');
  let variantData = null;
  
  if (variantDataStr) {
    try {
      const variants = JSON.parse(variantDataStr);
      variantData = variants[variantId];
    } catch (e) {
      console.error('Error parsing variant data:', e);
    }
  }
  
  // Update price elements within this specific product
  const priceElement = productContainer.querySelector('.price--highlight .money');
  const comparePriceElement = productContainer.querySelector('.price--compare .money');
  const discountElement = productContainer.querySelector('.discounted');
  
  // Update sale price - use innerHTML to preserve the money span structure
  if (priceElement && (variantPrice || variantData?.price)) {
    const newPrice = variantPrice || variantData.price;
    // If the price already contains HTML (like <span class="money">), use it as is
    if (newPrice.includes('<')) {
      priceElement.outerHTML = newPrice;
    } else {
      // Otherwise just update the text content
      priceElement.textContent = newPrice;
    }
  }
  
  // Update compare price
  if (comparePriceElement && (variantComparePrice || variantData?.comparePrice)) {
    const newComparePrice = variantComparePrice || variantData.comparePrice;
    if (newComparePrice.includes('<')) {
      comparePriceElement.outerHTML = newComparePrice;
    } else {
      comparePriceElement.textContent = newComparePrice;
    }
  }
  
  // Update discount
  if (discountElement && (variantDiscount || variantData?.discount)) {
    discountElement.textContent = variantDiscount || variantData.discount;
  }
  
  // Update ATC button/form with new variant ID
  updateAtcId(variantId, productContainer);
  
  // Optional: Trigger custom event for other scripts
  productContainer.dispatchEvent(new CustomEvent('variantChanged', { 
    detail: { 
      variantId: variantId,
      price: variantPrice || variantData?.price,
      comparePrice: variantComparePrice || variantData?.comparePrice
    },
    bubbles: true
  }));
  
}

/**
 * Update Add to Cart functionality with new variant ID
 * Scoped to specific product container
 * @param {string} variantId - The selected variant ID
 * @param {HTMLElement} productContainer - The specific product container element
 */
function updateAtcId(variantId, productContainer) {  
  // Update hidden input for variant ID (if exists - for ATC forms)
  const variantInput = productContainer.querySelector('input[name="id"][type="hidden"]');
  if (variantInput) {
    variantInput.value = variantId;
  }
  
  // Update any data attributes on ATC buttons (but don't change links)
  const atcButtons = productContainer.querySelectorAll('[data-add-to-cart]');
  atcButtons.forEach(button => {
    button.setAttribute('data-variant-id', variantId);
  });
}
document.addEventListener("DOMContentLoaded", ()=>{
  setTimeout(()=>{
    window.productFinderToggle();
    toggleConcerns();
    initializeSwatchUpdater();
    observeProductListChanges();
  },1000);
});
window.productFinderToggle = function () {
  document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
    const toggle = dropdown.querySelector('.dropdown-toggle');
    const items = dropdown.querySelectorAll('.dropdown-menu li');

    toggle.addEventListener('click', () => {
      dropdown.classList.toggle('open');
    });

    items.forEach(item => {
      item.addEventListener('click', () => {
        toggle.textContent = item.textContent;
        dropdown.classList.remove('open');

        // store selected value
        dropdown.dataset.selected = item.dataset.value;
      });
    });
  });
  // Close dropdowns on outside click
  document.addEventListener('click', e => {
    document.querySelectorAll('.custom-dropdown').forEach(dropdown => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('open');
      }
    });
  });

  const radios = document.querySelectorAll('input[name="finder-type"]');
  const sections = document.querySelectorAll('.finder-section');
  const button = document.getElementById('find_match');

  // Toggle Hair / Skin sections
  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      sections.forEach(section => {
        section.hidden = section.dataset.type !== radio.value;
      });
    });
  });
  if(!button) return;
  // Redirect logic (UL / LI dropdowns)
  button.addEventListener('click', () => {
    let activeType; 
    const activeRadio = document.querySelector('input[name="finder-type"]:checked');
    if (!activeRadio) {
      const element = document.querySelector('.finder-section'); 
      activeType = element ? element.getAttribute('data-type') : null; 
    } else {
      activeType = activeRadio.value;
    }

    const activeSections = document.querySelectorAll(
      `.finder-section[data-type="${activeType}"]`
    );

    var concernDisabled = '';
    var productDisabled = '';


    activeSections.forEach(section => {
      // skip hidden section
      if (!section.offsetParent) return;

      const concernDropdown = section.querySelector(
        '.custom-dropdown[data-filter="concerns"]'
      );

      const productDropdown = section.querySelector(
        '.custom-dropdown[data-filter="product_type_finder"]'
      );

      concernDisabled = concernDropdown?.querySelector('li[data-disabled="true"]') ? concernDropdown : null;
      productDisabled = productDropdown?.querySelector('li[data-disabled="true"]') ? productDropdown : null;
    });

    

    const concern = concernDisabled?.dataset.selected || '';
    const productType = productDisabled?.dataset.selected || '';

    // Stop if nothing selected
    if (!concern && !productType) {
      alert('Please select at least one option');
      return;
    }

    const params = new URLSearchParams();

    if (activeType == "skin" && concern) {
      params.append('filter.p.m.custom.concerns', concern);
    }

    if (activeType == "skin" && productType) {
      params.append('filter.p.m.custom.product_type_finder', productType);
    }

    if (activeType == "hair" && concern) {
      params.append('filter.p.m.custom.hair_concerns', concern);
    }


    if (activeType == "hair" && productType) {
      params.append('filter.p.m.custom.hair_product_type_finder', productType);
    }

    localStorage.setItem("concern_type", activeType);
    window.location.href = `/collections/product-finder?concern_type=${activeType}&${params.toString()}`;
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const goToTopButton = document.getElementById('st-back-to-top-collection');
  window.addEventListener('scroll', () => {
    const scrollY = document.documentElement.scrollTop;
    if (scrollY > 300) {
      goToTopButton.style.display = 'flex';
    } else {
      goToTopButton.style.display = 'none';
    }
  });
  goToTopButton.addEventListener('click', () => {
    const scrollToPosition = document.querySelector('.slider-container') ? 450 : 0;
    document.documentElement.scrollTo({ top: scrollToPosition, behavior: 'smooth' });
  });
});

